import api from "@/api/axios";
import Vue from "vue";

export async function markOrderViewed(orderId) {
  try {
    const response = await api.post(`/admin/orders/${orderId}/mark-viewed`);
    return response?.data?.admin_viewed_at ?? null;
  } catch (error) {
    if (error.response?.status !== 404) {
      throw error;
    }
  }

  const response = await api.get(`/admin/orders/${orderId}`);
  return response?.data?.data?.admin_viewed_at ?? null;
}

export function applyOrderViewedAt(ordersData, orderId, viewedAt) {
  if (!Array.isArray(ordersData) || orderId == null) {
    return;
  }

  const row = ordersData.find((o) => Number(o.id) === Number(orderId));
  if (row) {
    Vue.set(row, "admin_viewed_at", viewedAt || new Date().toISOString());
  }
}
